"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const home_1 = require("../../icon/home");
const profile_1 = require("../../icon/profile");
const react_router_dom_1 = require("react-router-dom");
const level_up_1 = require("../../icon/level-up");
const button_1 = require("../input/button");
const log_1 = require("../../model/log");
exports.AuthHeader = (0, react_1.memo)(({ userMeta }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 2, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/home", children: (0, jsx_runtime_1.jsx)(StyledButton, { eventName: log_1.LogEventClickName.HeaderHome, size: "large", startIcon: (0, jsx_runtime_1.jsx)(home_1.HomeIcon, {}), children: "Home" }) }), userMeta.enablePassageList && ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/list", children: (0, jsx_runtime_1.jsx)(StyledButton, { eventName: log_1.LogEventClickName.HeaderPassageList, size: "large", startIcon: (0, jsx_runtime_1.jsx)(level_up_1.LevelUpIcon, {}), children: "Level Up" }) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/settings", children: (0, jsx_runtime_1.jsx)(StyledButton, { eventName: log_1.LogEventClickName.HeaderSettings, size: "large", startIcon: (0, jsx_runtime_1.jsx)(profile_1.ProfileIcon, {}), children: "Profile" }) })] }));
});
exports.AuthHeader.displayName = "AuthHeader";
const StyledButton = (0, material_1.styled)(button_1.Button)(({ theme }) => ({
    borderRadius: theme.spacing(2),
    borderColor: "rgba(255, 255, 255, 0.3)",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: theme.palette.primary.contrastText,
}));
